import { Col, Container, Row } from 'react-bootstrap';
import ReactPlayer from 'react-player';

import styles from './landing.module.scss';
export default function OurClient() {
  return (
    <div className={styles.ourClientsWrapper}>
      <Container>
        <div className={styles.heading}>
          <h2>What Our Client Says</h2>
          <p className="mb-4">
            Find out what our clients think of our powerful but easy-to-use data
            management system!
          </p>
        </div>
        <Row>
          <Col md={6}>
            <div className={[styles.clientImage, 'mb-4'].join(' ')}>
              <ReactPlayer url="https://youtu.be/9mvXG1VRpQM" width="100%" />
            </div>
            <div className={[styles.clientImage, 'mb-4'].join(' ')}>
              <ReactPlayer url="https://youtu.be/PERNJJVGNIo" width="100%" />
            </div>
          </Col>
          <Col md={6}>
            <div className={[styles.clientImage, 'mb-4 mt-md-5'].join(' ')}>
              <ReactPlayer url="https://youtu.be/xpb5MxrpxaU" width="100%" />
            </div>
            <div className={[styles.clientImage, 'mb-4'].join(' ')}>
              <ReactPlayer url="https://youtu.be/nYxWmto-xBA" width="100%" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
